/**
 * Module organisations — les CABINETS (cliniques et centres dentaires).
 *
 * Vocabulaire fixé par Dove le 2026-08-05 :
 *   **Cabinet** = la clinique ou le centre dentaire (l'organisation) ;
 *   **Client**  = le dentiste individuel qui y travaille (module `praticiens`).
 * Ce module s'appelait « Clients » et servait la liste des cabinets — l'inverse
 * exact. Corrigé ici, avec redirections depuis les anciennes URL.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "organisations",
  label: "Cabinets",
  icon: "i-building",
  navGroup: "relations",
  navOrder: 10,
  rolesRequis: [],
  routes: [
    { path: "/cabinets", component: lazy(() => import("./routes/ListeCabinets")) },
    { path: "/cabinets/:id", component: lazy(() => import("./routes/FicheClient360")) },
    // Anciennes URL conservées : douze liens internes et d'éventuels favoris
    // pointaient vers /clients/<identifiant-de-cabinet>. On les redirige au lieu
    // de les casser — et surtout au lieu de les laisser atterrir sur un autre
    // objet, ce qui serait faux sans être visible.
    { path: "/clients", component: lazy(() => import("./routes/RedirectClients")) },
    { path: "/clients/:id", component: lazy(() => import("./routes/RedirectClients")) },
  ],
};

export default mod;
